export const DEVICE_RETIRE_TITLE = 'backoffice.devices.retire.title';

export const DEVICE_RETIRE_CONSEQUENCE = 'backoffice.devices.retire.consequence';

export const DEVICE_RETIRE_CONFIRM = 'backoffice.devices.retire.confirm';

export const DEVICE_RETIRED_MESSAGE = 'backoffice.devices.retire.done';
